// // // // // // import React, { useState, useEffect } from "react";
// // // // // // import { useNavigate } from "react-router-dom";
// // // // // // import { Button, Form, DropdownButton, Dropdown } from "react-bootstrap";
// // // // // // import { PDFDocument } from "pdf-lib";
// // // // // // import "bootstrap/dist/css/bootstrap.min.css";
// // // // // //
// // // // // // function QuizManager(props) {
// // // // // //   const navigate = useNavigate();
// // // // // //   const [filteredData, setFilteredData] = useState([]);
// // // // // //   const [selectedItems, setSelectedItems] = useState({});
// // // // // //   const [selectAll, setSelectAll] = useState(false);
// // // // // //   const [isProcessingPdfs, setIsProcessingPdfs] = useState(false);
// // // // // //
// // // // // //   useEffect(() => {
// // // // // //     setFilteredData(props.data);
// // // // // //   }, [props.data]);
// // // // // //
// // // // // //   const handleCheckboxChange = (quiz) => {
// // // // // //     const updated = { ...selectedItems };
// // // // // //     if (updated[quiz.id]) {
// // // // // //       delete updated[quiz.id];
// // // // // //     } else {
// // // // // //       updated[quiz.id] = quiz;
// // // // // //     }
// // // // // //     setSelectedItems(updated);
// // // // // //   };
// // // // // //
// // // // // //   const handleSelectAll = () => {
// // // // // //     if (selectAll) {
// // // // // //       setSelectedItems({});
// // // // // //     } else {
// // // // // //       const all = {};
// // // // // //       filteredData.forEach((quiz) => {
// // // // // //         if (quiz.PDF) all[quiz.id] = quiz;
// // // // // //       });
// // // // // //       setSelectedItems(all);
// // // // // //     }
// // // // // //     setSelectAll(!selectAll);
// // // // // //   };
// // // // // //
// // // // // //   const filterData = (e) => {
// // // // // //     const search = e.target.value.toLowerCase();
// // // // // //     const filtered = props.data.filter((item) =>
// // // // // //       ["title", "course", "instructor", "proctor"].some((key) =>
// // // // // //         item[key]?.toLowerCase().includes(search)
// // // // // //       )
// // // // // //     );
// // // // // //     setFilteredData(filtered);
// // // // // //   };
// // // // // //
// // // // // //   const handlePrintFiles = async () => {
// // // // // //     const selectedQuizzes = selectAll
// // // // // //       ? filteredData.filter((quiz) => quiz.PDF)
// // // // // //       : Object.values(selectedItems).filter((item) => item.PDF);
// // // // // //
// // // // // //     if (selectedQuizzes.length === 0) {
// // // // // //       alert("No PDF files selected or available.");
// // // // // //       return;
// // // // // //     }
// // // // // //
// // // // // //     setIsProcessingPdfs(true);
// // // // // //     let successfulPdfs = 0;
// // // // // //     let skippedPdfs = 0;
// // // // // //     const failedUrls = [];
// // // // // //
// // // // // //     try {
// // // // // //       const mergedPdf = await PDFDocument.create();
// // // // // //
// // // // // //       for (const quiz of selectedQuizzes) {
// // // // // //         try {
// // // // // //           const response = await fetch(quiz.PDF);
// // // // // //           if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
// // // // // //           const buffer = await response.arrayBuffer();
// // // // // //           const pdf = await PDFDocument.load(buffer);
// // // // // //           if (pdf.getPageCount() === 0) throw new Error("PDF has no pages");
// // // // // //
// // // // // //           const pages = await mergedPdf.copyPages(pdf, pdf.getPageIndices());
// // // // // //           pages.forEach((page) => mergedPdf.addPage(page));
// // // // // //           successfulPdfs++;
// // // // // //         } catch (err) {
// // // // // //           console.error(`Error processing PDF ${quiz.PDF}:`, err);
// // // // // //           skippedPdfs++;
// // // // // //           failedUrls.push({ url: quiz.PDF, title: quiz.title, error: err.message });
// // // // // //         }
// // // // // //       }
// // // // // //
// // // // // //       if (mergedPdf.getPageCount() === 0) {
// // // // // //         let errorMessage = `No valid PDF pages were found.\n\n`;
// // // // // //         errorMessage += `Successfully processed: ${successfulPdfs} PDF(s)\n`;
// // // // // //         errorMessage += `Skipped: ${skippedPdfs} PDF(s)\n\nFailed PDFs:\n`;
// // // // // //         failedUrls.forEach((item, i) => {
// // // // // //           errorMessage += `${i + 1}. ${item.title}\n   URL: ${item.url}\n   Error: ${item.error}\n\n`;
// // // // // //         });
// // // // // //         alert(errorMessage);
// // // // // //         return;
// // // // // //       }
// // // // // //
// // // // // //       const mergedPdfBytes = await mergedPdf.save();
// // // // // //       const blob = new Blob([mergedPdfBytes], { type: "application/pdf" });
// // // // // //       const blobUrl = URL.createObjectURL(blob);
// // // // // //
// // // // // //       const iframe = document.createElement("iframe");
// // // // // //       iframe.style.display = "none";
// // // // // //       iframe.src = blobUrl;
// // // // // //       iframe.onload = () => {
// // // // // //         try {
// // // // // //           iframe.contentWindow?.focus();
// // // // // //           iframe.contentWindow?.print();
// // // // // //         } catch (err) {
// // // // // //           console.error("Print error:", err);
// // // // // //           window.open(blobUrl, "_blank");
// // // // // //         }
// // // // // //         setTimeout(() => {
// // // // // //           document.body.removeChild(iframe);
// // // // // //           URL.revokeObjectURL(blobUrl);
// // // // // //         }, 1000);
// // // // // //       };
// // // // // //       document.body.appendChild(iframe);
// // // // // //
// // // // // //       if (skippedPdfs > 0) {
// // // // // //         let message = `Merged ${successfulPdfs} PDFs. Skipped ${skippedPdfs} due to errors.\n\nSkipped:\n`;
// // // // // //         failedUrls.forEach((item, i) => {
// // // // // //           message += `${i + 1}. ${item.title}\n`;
// // // // // //         });
// // // // // //         alert(message);
// // // // // //       }
// // // // // //
// // // // // //     } catch (err) {
// // // // // //       console.error("Error merging PDFs:", err);
// // // // // //       alert(`Failed to merge PDFs: ${err.message}`);
// // // // // //     } finally {
// // // // // //       setIsProcessingPdfs(false);
// // // // // //     }
// // // // // //   };
// // // // // //
// // // // // //   return (
// // // // // //     <div className="container">
// // // // // //       <h2>{props.title}</h2>
// // // // // //       <Form.Group className="mb-3">
// // // // // //         <Form.Control type="text" placeholder="Search Quizzes" onChange={filterData} />
// // // // // //       </Form.Group>
// // // // // //
// // // // // //       <div className="d-flex justify-content-between mb-3">
// // // // // //         <Button variant="secondary" onClick={handleSelectAll}>
// // // // // //           {selectAll ? "Deselect All" : "Select All"}
// // // // // //         </Button>
// // // // // //
// // // // // //         <DropdownButton title="Actions" variant="success" className="ms-2">
// // // // // //           {/*<Dropdown.Item onClick={() => navigate("/top/admin")}>Confirm Teacher</Dropdown.Item>*/}
// // // // // //           <Dropdown.Item onClick={() => navigate("/quizedit")}>Edit Quiz</Dropdown.Item>
// // // // // //           <Dropdown.Item onClick={() => navigate("/admincancel")}>Cancel Quiz</Dropdown.Item>
// // // // // //           <Dropdown.Item onClick={handlePrintFiles} disabled={isProcessingPdfs}>
// // // // // //             {isProcessingPdfs ? "Processing PDFs..." : "Print PDF(s)"}
// // // // // //           </Dropdown.Item>
// // // // // //           <Dropdown.Item onClick={() => navigate("/add/quiz")}>Add Quiz</Dropdown.Item>
// // // // // //           <Dropdown.Item onClick={() => navigate("/add/classes")}>Add Class</Dropdown.Item>
// // // // // //         </DropdownButton>
// // // // // //       </div>
// // // // // //
// // // // // //       {filteredData.length === 0 ? (
// // // // // //         <p>No quizzes found</p>
// // // // // //       ) : (
// // // // // //         <table className="table table-striped">
// // // // // //           <thead>
// // // // // //           <tr className="bg-dark-green">
// // // // // //             <th>Select</th>
// // // // // //             <th>Quiz Title</th>
// // // // // //             <th>Course</th>
// // // // // //             <th>Instructor</th>
// // // // // //             <th>Proctor</th>
// // // // // //             <th>PDF Link</th>
// // // // // //           </tr>
// // // // // //           </thead>
// // // // // //           <tbody>
// // // // // //           {filteredData.map((quiz) => (
// // // // // //             <tr key={quiz.id}>
// // // // // //               <td>
// // // // // //                 <Form.Check
// // // // // //                   type="checkbox"
// // // // // //                   checked={!!selectedItems[quiz.id]}
// // // // // //                   onChange={() => handleCheckboxChange(quiz)}
// // // // // //                   disabled={!quiz.PDF}
// // // // // //                 />
// // // // // //               </td>
// // // // // //               <td>{quiz.title}</td>
// // // // // //               <td>{quiz.course}</td>
// // // // // //               <td>{quiz.instructor}</td>
// // // // // //               <td>{quiz.proctor}</td>
// // // // // //               <td>
// // // // // //                 {quiz.PDF ? (
// // // // // //                   <a href={quiz.PDF} target="_blank" rel="noopener noreferrer">
// // // // // //                     View PDF
// // // // // //                   </a>
// // // // // //                 ) : (
// // // // // //                   "No PDF"
// // // // // //                 )}
// // // // // //               </td>
// // // // // //             </tr>
// // // // // //           ))}
// // // // // //           </tbody>
// // // // // //         </table>
// // // // // //       )}
// // // // // //     </div>
// // // // // //   );
// // // // // // }
// // // // // //
// // // // // // export default QuizManager;
// // // // //
// // // // // import React, { useState, useEffect } from "react";
// // // // // import { useNavigate } from "react-router-dom";
// // // // // import { Button, Form, DropdownButton, Dropdown } from "react-bootstrap";
// // // // // import "bootstrap/dist/css/bootstrap.min.css";
// // // // //
// // // // // function QuizManager(props) {
// // // // //   const navigate = useNavigate();
// // // // //   const [filteredData, setFilteredData] = useState([]);
// // // // //   const [selectedItems, setSelectedItems] = useState({});
// // // // //   const [selectAll, setSelectAll] = useState(false);
// // // // //
// // // // //   useEffect(() => {
// // // // //     setFilteredData(props.data);
// // // // //   }, [props.data]);
// // // // //
// // // // //   const handleCheckboxChange = (quiz) => {
// // // // //     const updated = { ...selectedItems };
// // // // //     if (updated[quiz.id]) {
// // // // //       delete updated[quiz.id];
// // // // //     } else {
// // // // //       updated[quiz.id] = quiz;
// // // // //     }
// // // // //     setSelectedItems(updated);
// // // // //   };
// // // // //
// // // // //   const handleSelectAll = () => {
// // // // //     if (selectAll) {
// // // // //       setSelectedItems({});
// // // // //     } else {
// // // // //       const all = {};
// // // // //       filteredData.forEach((quiz) => {
// // // // //         if (quiz.PDF) all[quiz.id] = quiz;
// // // // //       });
// // // // //       setSelectedItems(all);
// // // // //     }
// // // // //     setSelectAll(!selectAll);
// // // // //   };
// // // // //
// // // // //   const filterData = (e) => {
// // // // //     const search = e.target.value.toLowerCase();
// // // // //     const filtered = props.data.filter((item) =>
// // // // //       ["title", "course"].some((key) =>
// // // // //         item[key]?.toLowerCase().includes(search)
// // // // //       )
// // // // //     );
// // // // //     setFilteredData(filtered);
// // // // //   };
// // // // //
// // // // //   return (
// // // // //     <div className="container">
// // // // //       <h2>{props.title}</h2>
// // // // //       <Form.Group className="mb-3">
// // // // //         <Form.Control type="text" placeholder="Search Quizzes" onChange={filterData} />
// // // // //       </Form.Group>
// // // // //
// // // // //       <div className="d-flex justify-content-between mb-3">
// // // // //         <DropdownButton title="Actions" variant="success" className="ms-2">
// // // // //           <Dropdown.Item onClick={() => navigate("/quizedit")}>Edit Quiz</Dropdown.Item>
// // // // //           <Dropdown.Item onClick={() => navigate("/admincancel")}>Cancel Quiz</Dropdown.Item>
// // // // //           <Dropdown.Item onClick={() => navigate("/add/quiz")}>Add Quiz</Dropdown.Item>
// // // // //           <Dropdown.Item onClick={() => navigate("/add/classes")}>Add Class</Dropdown.Item>
// // // // //         </DropdownButton>
// // // // //       </div>
// // // // //
// // // // //       {filteredData.length === 0 ? (
// // // // //         <div>
// // // // //           <p>No quizzes found</p>
// // // // //           <Button variant="secondary" onClick={handleSelectAll}>
// // // // //             {selectAll ? "Deselect All" : "Select All"}
// // // // //           </Button>
// // // // //         </div>
// // // // //       ) : (
// // // // //         <table className="table table-striped">
// // // // //           <thead>
// // // // //           <tr className="bg-dark-green">
// // // // //             <th>Select</th>
// // // // //             <th>Quiz Title</th>
// // // // //             <th>Course</th>
// // // // //             <th>PDF Link</th>
// // // // //           </tr>
// // // // //           </thead>
// // // // //           <tbody>
// // // // //           {filteredData.map((quiz) => (
// // // // //             <tr key={quiz.id}>
// // // // //               <td>
// // // // //                 <Form.Check
// // // // //                   type="checkbox"
// // // // //                   checked={!!selectedItems[quiz.id]}
// // // // //                   onChange={() => handleCheckboxChange(quiz)}
// // // // //                   disabled={!quiz.PDF}
// // // // //                 />
// // // // //               </td>
// // // // //               <td>{quiz.title}</td>
// // // // //               <td>{quiz.course}</td>
// // // // //               <td>
// // // // //                 {quiz.PDF ? (
// // // // //                   <a href={quiz.PDF} target="_blank" rel="noopener noreferrer">
// // // // //                     View PDF
// // // // //                   </a>
// // // // //                 ) : (
// // // // //                   "No PDF"
// // // // //                 )}
// // // // //               </td>
// // // // //             </tr>
// // // // //           ))}
// // // // //           </tbody>
// // // // //         </table>
// // // // //       )}
// // // // //     </div>
// // // // //   );
// // // // // }
// // // // //
// // // // // export default QuizManager;
// // // //
// // // // import React, { useState, useEffect } from "react";
// // // // import { useNavigate } from "react-router-dom";
// // // // import { Button, Form, DropdownButton, Dropdown } from "react-bootstrap";
// // // // import { PDFDocument } from "pdf-lib";
// // // // import "bootstrap/dist/css/bootstrap.min.css";
// // // //
// // // // function QuizManager(props) {
// // // //   const navigate = useNavigate();
// // // //   const [filteredData, setFilteredData] = useState([]);
// // // //   const [selectedItems, setSelectedItems] = useState({});
// // // //   const [selectAll, setSelectAll] = useState(false);
// // // //   const [isProcessingPdfs, setIsProcessingPdfs] = useState(false);
// // // //
// // // //   useEffect(() => {
// // // //     setFilteredData(props.data);
// // // //   }, [props.data]);
// // // //
// // // //   const handleCheckboxChange = (quiz) => {
// // // //     const updated = { ...selectedItems };
// // // //     if (updated[quiz.id]) {
// // // //       delete updated[quiz.id];
// // // //     } else {
// // // //       updated[quiz.id] = quiz;
// // // //     }
// // // //     setSelectedItems(updated);
// // // //   };
// // // //
// // // //   const handleSelectAll = () => {
// // // //     if (selectAll) {
// // // //       setSelectedItems({});
// // // //     } else {
// // // //       const all = {};
// // // //       filteredData.forEach((quiz) => {
// // // //         if (quiz.PDF) all[quiz.id] = quiz;
// // // //       });
// // // //       setSelectedItems(all);
// // // //     }
// // // //     setSelectAll(!selectAll);
// // // //   };
// // // //
// // // //   const filterData = (e) => {
// // // //     const search = e.target.value.toLowerCase();
// // // //     const filtered = props.data.filter((item) =>
// // // //       ["title", "course"].some((key) =>
// // // //         item[key]?.toLowerCase().includes(search)
// // // //       )
// // // //     );
// // // //     setFilteredData(filtered);
// // // //   };
// // // //
// // // //   const handleViewCombinedPDF = async () => {
// // // //     const selectedQuizzes = Object.values(selectedItems).filter((item) => item.PDF);
// // // //
// // // //     if (selectedQuizzes.length === 0) {
// // // //       alert("No PDF files selected or available.");
// // // //       return;
// // // //     }
// // // //
// // // //     setIsProcessingPdfs(true);
// // // //
// // // //     try {
// // // //       const mergedPdf = await PDFDocument.create();
// // // //
// // // //       for (const quiz of selectedQuizzes) {
// // // //         const response = await fetch(quiz.PDF);
// // // //         const buffer = await response.arrayBuffer();
// // // //         const pdf = await PDFDocument.load(buffer);
// // // //         const pages = await mergedPdf.copyPages(pdf, pdf.getPageIndices());
// // // //         pages.forEach((page) => mergedPdf.addPage(page));
// // // //       }
// // // //
// // // //       const mergedPdfBytes = await mergedPdf.save();
// // // //       const blob = new Blob([mergedPdfBytes], { type: "application/pdf" });
// // // //       const blobUrl = URL.createObjectURL(blob);
// // // //
// // // //       window.open(blobUrl, "_blank");
// // // //     } catch (err) {
// // // //       console.error("Error merging PDFs:", err);
// // // //       alert(`Failed to merge PDFs: ${err.message}`);
// // // //     } finally {
// // // //       setIsProcessingPdfs(false);
// // // //     }
// // // //   };
// // // //
// // // //   return (
// // // //     <div className="container">
// // // //       <h2>{props.title}</h2>
// // // //       <Form.Group className="mb-3">
// // // //         <Form.Control type="text" placeholder="Search Quizzes" onChange={filterData} />
// // // //       </Form.Group>
// // // //
// // // //       {filteredData.length === 0 ? (
// // // //         <div>
// // // //           <p>No quizzes found</p>
// // // //           <Button variant="secondary" onClick={handleSelectAll}>
// // // //             {selectAll ? "Deselect All" : "Select All"}
// // // //           </Button>
// // // //         </div>
// // // //       ) : (
// // // //         <>
// // // //           <div className="d-flex justify-content-between mb-3">
// // // //             <DropdownButton title="Actions" variant="success" className="ms-2">
// // // //               <Dropdown.Item onClick={() => navigate("/quizedit")}>Edit Quiz</Dropdown.Item>
// // // //               <Dropdown.Item onClick={() => navigate("/admincancel")}>Cancel Quiz</Dropdown.Item>
// // // //               <Dropdown.Item onClick={handleViewCombinedPDF} disabled={isProcessingPdfs}>
// // // //                 {isProcessingPdfs ? "Processing PDFs..." : "View Combined PDF"}
// // // //               </Dropdown.Item>
// // // //               <Dropdown.Item onClick={() => navigate("/add/quiz")}>Add Quiz</Dropdown.Item>
// // // //               <Dropdown.Item onClick={() => navigate("/add/classes")}>Add Class</Dropdown.Item>
// // // //             </DropdownButton>
// // // //           </div>
// // // //
// // // //           <table className="table table-striped">
// // // //             <thead>
// // // //             <tr className="bg-dark-green">
// // // //               <th>Select</th>
// // // //               <th>Quiz Title</th>
// // // //               <th>Course</th>
// // // //               <th>PDF Link</th>
// // // //             </tr>
// // // //             </thead>
// // // //             <tbody>
// // // //             {filteredData.map((quiz) => (
// // // //               <tr key={quiz.id}>
// // // //                 <td>
// // // //                   <Form.Check
// // // //                     type="checkbox"
// // // //                     checked={!!selectedItems[quiz.id]}
// // // //                     onChange={() => handleCheckboxChange(quiz)}
// // // //                     disabled={!quiz.PDF}
// // // //                   />
// // // //                 </td>
// // // //                 <td>{quiz.title}</td>
// // // //                 <td>{quiz.course}</td>
// // // //                 <td>
// // // //                   {quiz.PDF ? (
// // // //                     <a href={quiz.PDF} target="_blank" rel="noopener noreferrer">
// // // //                       View PDF
// // // //                     </a>
// // // //                   ) : (
// // // //                     "No PDF"
// // // //                   )}
// // // //                 </td>
// // // //               </tr>
// // // //             ))}
// // // //             </tbody>
// // // //           </table>
// // // //         </>
// // // //       )}
// // // //     </div>
// // // //   );
// // // // }
// // // //
// // // // export default QuizManager;
// // // import React, { useState, useEffect } from "react";
// // // import { Button, Form, DropdownButton, Dropdown } from "react-bootstrap";
// // // import "bootstrap/dist/css/bootstrap.min.css";
// // // import { useNavigate } from 'react-router-dom';
// // //
// // //
// // // function QuizManager(props) {
// // //   const [filteredData, setFilteredData] = useState([]);
// // //
// // //   useEffect(() => {
// // //     setFilteredData(props.data);
// // //   }, [props.data]);
// // //
// // //   const filterData = (e) => {
// // //     const search = e.target.value.toLowerCase();
// // //     const filtered = props.data.filter((item) =>
// // //       ["title", "course"].some((key) =>
// // //         item[key]?.toLowerCase().includes(search)
// // //       )
// // //     );
// // //     setFilteredData(filtered);
// // //   };
// // //
// // //   return (
// // //     <div className="container">
// // //       <h2>{props.title}</h2>
// // //       <Form.Group className="mb-3">
// // //         <Form.Control type="text" placeholder="Search Quizzes" onChange={filterData} />
// // //       </Form.Group>
// // //
// // //       <div className="d-flex justify-content-between mb-3">
// // //         <DropdownButton title="Actions" variant="success" className="ms-2">
// // //           <Dropdown.Item onClick={() => navigate("/quizedit")}>Edit Quiz</Dropdown.Item>
// // //           <Dropdown.Item onClick={() => navigate("/admincancel")}>Cancel Quiz</Dropdown.Item>
// // //           <Dropdown.Item onClick={() => navigate("/add/quiz")}>Add Quiz</Dropdown.Item>
// // //           <Dropdown.Item onClick={() => navigate("/add/classes")}>Add Class</Dropdown.Item>
// // //         </DropdownButton>
// // //       </div>
// // //
// // //       {filteredData.length === 0 ? (
// // //         <p>No quizzes found</p>
// // //       ) : (
// // //         <table className="table table-striped">
// // //           <thead>
// // //           <tr>
// // //             <th>Quiz Title</th>
// // //             <th>Course</th>
// // //             <th>PDF Link</th>
// // //           </tr>
// // //           </thead>
// // //           <tbody>
// // //           {filteredData.map((quiz) => (
// // //             <tr key={quiz.id}>
// // //               <td>{quiz.title}</td>
// // //               <td>{quiz.course}</td>
// // //               <td>
// // //                 {quiz.PDF ? (
// // //                   <a href={quiz.PDF} target="_blank" rel="noopener noreferrer">
// // //                     View PDF
// // //                   </a>
// // //                 ) : (
// // //                   "No PDF"
// // //                 )}
// // //               </td>
// // //             </tr>
// // //           ))}
// // //           </tbody>
// // //         </table>
// // //       )}
// // //     </div>
// // //   );
// // // }
// // //
// // // export default QuizManager;
// // import React, { useState, useEffect } from "react";
// // import { Button, Form, DropdownButton, Dropdown } from "react-bootstrap";
// // import { useNavigate } from "react-router-dom"; // Import useNavigate hook
// // import "bootstrap/dist/css/bootstrap.min.css";
// // import 'spec-web-app/src/App.css'; // Import the CSS file
// //
// // function QuizManager(props) {
// //   const [filteredData, setFilteredData] = useState([]);
// //   const navigate = useNavigate(); // Initialize navigate function
// //
// //   useEffect(() => {
// //     setFilteredData(props.data);
// //   }, [props.data]);
// //
// //   const filterData = (e) => {
// //     const search = e.target.value.toLowerCase();
// //     const filtered = props.data.filter((item) =>
// //       ["title", "course"].some((key) =>
// //         item[key]?.toLowerCase().includes(search)
// //       )
// //     );
// //     setFilteredData(filtered);
// //   };
// //
// //   return (
// //     <div className="container">
// //       <h2>{props.title}</h2>
// //       <Form.Group className="mb-3">
// //         <Form.Control type="text" placeholder="Search Quizzes" onChange={filterData} />
// //       </Form.Group>
// //
// //       <div className="d-flex justify-content-between mb-3">
// //         <DropdownButton title="Actions" variant="success" className="ms-2">
// //           <Dropdown.Item onClick={() => navigate("/quizedit")}>Edit Quiz</Dropdown.Item>
// //           <Dropdown.Item onClick={() => navigate("/admincancel")}>Cancel Quiz</Dropdown.Item>
// //           <Dropdown.Item onClick={() => navigate("/add/quiz")}>Add Quiz</Dropdown.Item>
// //           <Dropdown.Item onClick={() => navigate("/add/classes")}>Add Class</Dropdown.Item>
// //         </DropdownButton>
// //       </div>
// //
// //       {filteredData.length === 0 ? (
// //         <p>No quizzes found</p>
// //       ) : (
// //         <table className="table table-striped">
// //           <thead>
// //           <tr>
// //             <th className="dark-green-header">Quiz Title</th>
// //             <th className="dark-green-header">Course</th>
// //             <th className="dark-green-header">PDF Link</th>
// //           </tr>
// //           </thead>
// //           <tbody>
// //           {filteredData.map((quiz) => (
// //             <tr key={quiz.id}>
// //               <td>{quiz.title}</td>
// //               <td>{quiz.course}</td>
// //               <td>
// //                 {quiz.PDF ? (
// //                   <a href={quiz.PDF} target="_blank" rel="noopener noreferrer">
// //                     View PDF
// //                   </a>
// //                 ) : (
// //                   "No PDF"
// //                 )}
// //               </td>
// //             </tr>
// //           ))}
// //           </tbody>
// //         </table>
// //       )}
// //     </div>
// //   );
// // }
// //
// // export default QuizManager;
// import React, { useState, useEffect } from "react";
// import { useNavigate } from "react-router-dom";
// import { Button, Form, DropdownButton, Dropdown } from "react-bootstrap";
// import "bootstrap/dist/css/bootstrap.min.css";
// import 'spec-web-app/src/App.css';
//
// function QuizManager(props) {
//   const [filteredData, setFilteredData] = useState([]);
//   const navigate = useNavigate();
//
//   useEffect(() => {
//     console.log("Received props.data:", props.data);
//     setFilteredData(props.data || []);
//   }, [props.data]);
//
//   const filterData = (e) => {
//     const search = e.target.value.toLowerCase();
//     console.log("Search term:", search);
//
//     const filtered = (props.data || []).filter((item) =>
//       ["title", "course"].some((key) =>
//         item[key]?.toString().toLowerCase().includes(search)
//       )
//     );
//
//     console.log("Filtered results:", filtered);
//     setFilteredData(filtered);
//   };
//
//   const handlePrintFiles = async () => {
//     const selectedQuizzes = selectAll
//       ? filteredData.filter((quiz) => quiz.PDF)
//       : Object.values(selectedItems).filter((item) => item.PDF);
//
//     if (selectedQuizzes.length === 0) {
//       alert("No PDF files selected or available.");
//       return;
//     }
//
//     setIsProcessingPdfs(true);
//     let successfulPdfs = 0;
//     let skippedPdfs = 0;
//     const failedUrls = [];
//
//     try {
//       const mergedPdf = await PDFDocument.create();
//
//       for (const quiz of selectedQuizzes) {
//         try {
//           const response = await fetch(quiz.PDF);
//           if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
//
//           const buffer = await response.arrayBuffer();
//           const pdf = await PDFDocument.load(buffer);
//
//           if (pdf.getPageCount() === 0) {
//             throw new Error("PDF has no pages");
//           }
//
//           const pages = await mergedPdf.copyPages(pdf, pdf.getPageIndices());
//           pages.forEach((page) => mergedPdf.addPage(page));
//           successfulPdfs++;
//         } catch (err) {
//           console.error(`Error processing PDF ${quiz.PDF}:`, err);
//           skippedPdfs++;
//           failedUrls.push({ url: quiz.PDF, title: quiz.title, error: err.message });
//         }
//       }
//
//       if (mergedPdf.getPageCount() === 0) {
//         let errorMessage = "No valid PDF pages were found.\n\n";
//         errorMessage += `Successfully processed: ${successfulPdfs} PDF(s)\n`;
//         errorMessage += `Skipped: ${skippedPdfs} PDF(s)\n\nFailed PDFs:\n`;
//         failedUrls.forEach((item, index) => {
//           errorMessage += `${index + 1}. ${item.title}\n   URL: ${item.url}\n   Error: ${item.error}\n\n`;
//         });
//         alert(errorMessage);
//         return;
//       }
//
//       const mergedPdfBytes = await mergedPdf.save();
//       const blob = new Blob([mergedPdfBytes], { type: "application/pdf" });
//       const blobUrl = URL.createObjectURL(blob);
//
//       const iframe = document.createElement("iframe");
//       iframe.style.display = "none";
//       iframe.src = blobUrl;
//       iframe.onload = () => {
//         try {
//           iframe.contentWindow?.focus();
//           iframe.contentWindow?.print();
//         } catch (err) {
//           console.error("Print error:", err);
//           window.open(blobUrl, "_blank");
//         }
//         setTimeout(() => {
//           document.body.removeChild(iframe);
//           URL.revokeObjectURL(blobUrl);
//         }, 1000);
//       };
//       document.body.appendChild(iframe);
//
//       if (skippedPdfs > 0) {
//         let successMessage = `Successfully merged ${successfulPdfs} PDF(s) with ${mergedPdf.getPageCount()} total pages.\n`;
//         successMessage += `Skipped ${skippedPdfs} PDF(s).\n\nThe following PDFs were skipped:\n`;
//         failedUrls.forEach((item, index) => {
//           successMessage += `${index + 1}. ${item.title}\n`;
//         });
//         alert(successMessage);
//       }
//
//     } catch (err) {
//       console.error("Error merging PDFs:", err);
//       alert(`Failed to merge PDFs: ${err.message}`);
//     } finally {
//       setIsProcessingPdfs(false);
//     }
//   };
//
//   return (
//     <div className="container">
//       <h2>{props.title}</h2>
//
//       <Form.Group className="mb-3">
//         <Form.Control
//           type="text"
//           placeholder="Search Quizzes"
//           onChange={filterData}
//         />
//       </Form.Group>
//
//       <div className="d-flex justify-content-between mb-3">
//         <Button variant="secondary" onClick={handleSelectAll}>
//           {selectAll ? "Deselect All" : "Select All"}
//         </Button>
//
//         <DropdownButton title="Actions" variant="success">
//           <Dropdown.Item onClick={() => navigate("/top/admin")}>Confirm Teacher</Dropdown.Item>
//           <Dropdown.Item onClick={() => navigate("/quizedit")}>Edit Quiz</Dropdown.Item>
//           <Dropdown.Item onClick={() => navigate("/admincancel")}>Cancel Quiz</Dropdown.Item>
//           <Dropdown.Item onClick={handlePrintFiles} disabled={isProcessingPdfs}>
//             {isProcessingPdfs ? "Processing PDFs..." : "Print PDF(s)"}
//           </Dropdown.Item>
//           <Dropdown.Item onClick={() => navigate("/add/quiz")}>Add Quiz</Dropdown.Item>
//           <Dropdown.Item onClick={() => navigate("/add/classes")}>Add Class</Dropdown.Item>
//         </DropdownButton>
//       </div>
//
//       {filteredData.length === 0 ? (
//         <p>No quizzes found</p>
//       ) : (
//         <table className="table table-striped">
//           <thead>
//             <tr className="bg-dark-green">
//               <th>Select</th>
//               <th>Quiz Title</th>
//               <th>Course</th>
//               <th>Instructor</th>
//               <th>Proctor</th>
//               <th>PDF Link</th>
//             </tr>
//           </thead>
//           <tbody>
//             {filteredData.map((quiz) => (
//               <tr key={quiz.id}>
//                 <td>
//                   <Form.Check
//                     type="checkbox"
//                     checked={!!selectedItems[quiz.id]}
//                     onChange={() => handleCheckboxChange(quiz)}
//                     disabled={!quiz.PDF}
//                   />
//                 </td>
//                 <td>{quiz.title}</td>
//                 <td>{quiz.course}</td>
//                 <td>{quiz.instructor}</td>
//                 <td>{quiz.proctor}</td>
//                 <td>
//                   {quiz.PDF ? (
//                     <a href={quiz.PDF} target="_blank" rel="noopener noreferrer">
//                       View PDF
//                     </a>
//                   ) : (
//                     "No PDF"
//                   )}
//                 </td>
//               </tr>
//             ))}
//           </tbody>
//         </table>
//       )}
//     </div>
//   );
// }
//
// export default QuizManager;
import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Button, Form, DropdownButton, Dropdown } from "react-bootstrap";
import { PDFDocument } from "pdf-lib";
import "bootstrap/dist/css/bootstrap.min.css";
import '../App.css';

function QuizManager(props) {
  const [filteredData, setFilteredData] = useState([]);
  const [selectedItems, setSelectedItems] = useState({});
  const [selectAll, setSelectAll] = useState(false);
  const [isProcessingPdfs, setIsProcessingPdfs] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    console.log("Received props.data:", props.data);
    setFilteredData(props.data || []);
  }, [props.data]);

  const filterData = (e) => {
    const search = e.target.value.toLowerCase();
    console.log("Search term:", search);

    const filtered = (props.data || []).filter((item) =>
      ["title", "course"].some((key) =>
        item[key]?.toString().toLowerCase().includes(search)
      )
    );

    console.log("Filtered results:", filtered);
    setFilteredData(filtered);
  };

  const handleCheckboxChange = (quiz) => {
    setSelectedItems((prev) => ({
      ...prev,
      [quiz.id]: prev[quiz.id] ? null : quiz,
    }));
  };

  const handleSelectAll = () => {
    const newSelectAll = !selectAll;
    setSelectAll(newSelectAll);
    if (newSelectAll) {
      const selected = {};
      filteredData.forEach((quiz) => {
        if (quiz.PDF) selected[quiz.id] = quiz;
      });
      setSelectedItems(selected);
    } else {
      setSelectedItems({});
    }
  };

  const handlePrintFiles = async () => {
    const selectedQuizzes = selectAll
      ? filteredData.filter((quiz) => quiz.PDF)
      : Object.values(selectedItems).filter((item) => item?.PDF);

    if (selectedQuizzes.length === 0) {
      alert("No PDF files selected or available.");
      return;
    }

    setIsProcessingPdfs(true);
    let successfulPdfs = 0;
    let skippedPdfs = 0;
    const failedUrls = [];

    try {
      const mergedPdf = await PDFDocument.create();

      for (const quiz of selectedQuizzes) {
        try {
          const response = await fetch(quiz.PDF);
          if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);

          const buffer = await response.arrayBuffer();
          const pdf = await PDFDocument.load(buffer);

          if (pdf.getPageCount() === 0) {
            throw new Error("PDF has no pages");
          }

          const pages = await mergedPdf.copyPages(pdf, pdf.getPageIndices());
          pages.forEach((page) => mergedPdf.addPage(page));
          successfulPdfs++;
        } catch (err) {
          console.error(`Error processing PDF ${quiz.PDF}:`, err);
          skippedPdfs++;
          failedUrls.push({ url: quiz.PDF, title: quiz.title, error: err.message });
        }
      }

      if (mergedPdf.getPageCount() === 0) {
        let errorMessage = "No valid PDF pages were found.\n\n";
        errorMessage += `Successfully processed: ${successfulPdfs} PDF(s)\n`;
        errorMessage += `Skipped: ${skippedPdfs} PDF(s)\n\nFailed PDFs:\n`;
        failedUrls.forEach((item, index) => {
          errorMessage += `${index + 1}. ${item.title}\n   URL: ${item.url}\n   Error: ${item.error}\n\n`;
        });
        alert(errorMessage);
        return;
      }

      const mergedPdfBytes = await mergedPdf.save();
      const blob = new Blob([mergedPdfBytes], { type: "application/pdf" });
      const blobUrl = URL.createObjectURL(blob);

      const iframe = document.createElement("iframe");
      iframe.style.display = "none";
      iframe.src = blobUrl;
      iframe.onload = () => {
        try {
          iframe.contentWindow?.focus();
          iframe.contentWindow?.print();
        } catch (err) {
          console.error("Print error:", err);
          window.open(blobUrl, "_blank");
        }
        setTimeout(() => {
          document.body.removeChild(iframe);
          URL.revokeObjectURL(blobUrl);
        }, 1000);
      };
      document.body.appendChild(iframe);

      if (skippedPdfs > 0) {
        let successMessage = `Successfully merged ${successfulPdfs} PDF(s) with ${mergedPdf.getPageCount()} total pages.\n`;
        successMessage += `Skipped ${skippedPdfs} PDF(s).\n\nThe following PDFs were skipped:\n`;
        failedUrls.forEach((item, index) => {
          successMessage += `${index + 1}. ${item.title}\n`;
        });
        alert(successMessage);
      }

    } catch (err) {
      console.error("Error merging PDFs:", err);
      alert(`Failed to merge PDFs: ${err.message}`);
    } finally {
      setIsProcessingPdfs(false);
    }
  };

  return (
    <div className="container">
      <h2>{props.title}</h2>

      <Form.Group className="mb-3">
        <Form.Control
          type="text"
          placeholder="Search Quizzes"
          onChange={filterData}
        />
      </Form.Group>

      <div className="d-flex justify-content-between mb-3">
        <Button variant="secondary" onClick={handleSelectAll}>
          {selectAll ? "Deselect All" : "Select All"}
        </Button>

        <DropdownButton title="Actions" variant="success">
          <Dropdown.Item onClick={() => navigate("/top/admin")}>Confirm Teacher</Dropdown.Item>
          <Dropdown.Item onClick={() => navigate("/quizedit")}>Edit Quiz</Dropdown.Item>
          <Dropdown.Item onClick={() => navigate("/admincancel")}>Cancel Quiz</Dropdown.Item>
          <Dropdown.Item onClick={handlePrintFiles} disabled={isProcessingPdfs}>
            {isProcessingPdfs ? "Processing PDFs..." : "Print PDF(s)"}
          </Dropdown.Item>
          <Dropdown.Item onClick={() => navigate("/add/quiz")}>Add Quiz</Dropdown.Item>
          <Dropdown.Item onClick={() => navigate("/add/classes")}>Add Class</Dropdown.Item>
        </DropdownButton>
      </div>

      {filteredData.length === 0 ? (
        <p>No quizzes found</p>
      ) : (
        <table className="table table-striped">
          <thead>
          <tr className="bg-dark-green">
            <th>Select</th>
            <th>Quiz Title</th>
            <th>Course</th>
            <th>Instructor</th>
            <th>Proctor</th>
            <th>PDF Link</th>
          </tr>
          </thead>
          <tbody>
          {filteredData.map((quiz) => (
            <tr key={quiz.id}>
              <td>
                <Form.Check
                  type="checkbox"
                  checked={!!selectedItems[quiz.id]}
                  onChange={() => handleCheckboxChange(quiz)}
                  disabled={!quiz.PDF}
                />
              </td>
              <td>{quiz.title}</td>
              <td>{quiz.course}</td>
              <td>{quiz.instructor}</td>
              <td>{quiz.proctor}</td>
              <td>
                {quiz.PDF ? (
                  <a href={quiz.PDF} target="_blank" rel="noopener noreferrer">
                    View PDF
                  </a>
                ) : (
                  "No PDF"
                )}
              </td>
            </tr>
          ))}
          </tbody>
        </table>
      )}
    </div>
  );
}

export default QuizManager;
